export default __webpack_public_path__ + "static/media/bg-6.301d71d5.png";